import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";

export default {
  DoGenerateSASToken(input) {
    return API.peakFileService.post("/api/Token/GenerateSASToken", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
};
